/** Preserve error grouping and correlation, never raw request, actor or exception text. */
export function sanitizeEvent<
  T extends {
    request?: unknown;
    user?: unknown;
    extra?: unknown;
    breadcrumbs?: unknown;
    exception?: { values?: { value?: string }[] };
  },
>(event: T): T {
  delete event.request;
  delete event.user;
  delete event.extra;
  delete event.breadcrumbs;
  for (const exception of event.exception?.values ?? [])
    exception.value = "Application exception (details redacted)";
  return event;
}
